import common from './common'

const dark = {
  ...common.button,
  color: `omegaLighter`,
  bg: `omegaDark`,
  borderColor: `omegaDark`,
  ':hover': {
    color: `white`,
    bg: `alpha`,
    borderColor: `alpha`
  }
}

export default dark